import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5" }
const _hoisted_2 = { class: "flex justify-between items-center gap-3 col-span-12 flex-wrap" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "col-span-12" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "col-span-12 flex flex-col gap-5" }
const _hoisted_7 = { class: "p-3 border-b flex justify-between items-center" }
const _hoisted_8 = { class: "p-input-icon-right w-fit" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_10 = { class: "flex items-center gap-3" }
const _hoisted_11 = { class: "hidden md:flex" }
const _hoisted_12 = {
  key: 0,
  class: "py-32 bg-gray-100"
}
const _hoisted_13 = {
  key: 1,
  class: "bg-gray-100 p-5 grid grid-cols-12 gap-3"
}
const _hoisted_14 = { class: "bg-white p-3 flex flex-wrap justify-between items-center border-b-4 border-h-primary-500 rounded-md shadow-md overflow-hidden" }
const _hoisted_15 = ["title", "for"]
const _hoisted_16 = { class: "flex items-center gap-2" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "line-clamp-2 w-7/12 font-[600]" }
const _hoisted_19 = {
  key: 2,
  class: "flex justify-end items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        class: "grid grid-cols-12 gap-5 lg:gap-8 text-black",
        autocomplete: "off"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Informações da turma",
              en: "Class info",
            })), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              id: "cancel-class-btn",
              label: _ctx.$t('labels.cancel'),
              class: "btn-outline p-button-sm",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmModal()))
            }, null, 8, ["label"]),
            _createVNode(_component_Button, {
              id: "continue-class-btn",
              label: _ctx.$t('labels.continue'),
              type: "submit",
              class: "btn-primary p-button-sm",
              loading: _ctx.loading
            }, null, 8, ["label", "loading"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("classes.create.inputs.name")), 1),
          _createVNode(_component_InputText, {
            id: "title-input",
            type: "text",
            name: "name",
            modelValue: _ctx.data.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.name) = $event)),
            class: _normalizeClass(_ctx.v$.data.name.$error ? 'p-invalid' : ''),
            maxlength: 50
          }, null, 8, ["modelValue", "class"]),
          _createVNode(_component_Errors, {
            errors: _ctx.v$.data.name.$errors,
            actualLength: _ctx.data.name?.length,
            maxLength: 50
          }, null, 8, ["errors", "actualLength"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t("classes.create.inputs.select")), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["bg-white border rounded-md", _ctx.v$.selected.$error ? 'border-red-500' : ''])
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_InputText, {
                    id: "search-for-input",
                    type: "text",
                    modelValue: _ctx.searchFor,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFor) = $event)),
                    placeholder: 
                    _ctx.$t('labels.generic', {
                      pt: 'Pesquisar curso',
                      en: 'Search course',
                    })
                  ,
                    class: "p-inputtext-sm",
                    onKeyup: _ctx.filterFor
                  }, null, 8, ["modelValue", "placeholder", "onKeyup"]),
                  _hoisted_9
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("labels.generic", {
                      pt: "Selecionar toda a página",
                      en: "Select all page",
                    })), 1),
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.selectAll,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectAll) = $event)),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectAllCourses())),
                    binary: true
                  }, null, 8, ["modelValue"])
                ])
              ]),
              (_ctx.loader)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_Loader, {
                      loader: _ctx.loader,
                      loaderSize: "h-full"
                    }, null, 8, ["loader"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.loader)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "col-span-12 sm:col-span-6 lg:col-span-4"
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("label", {
                            id: "label-course",
                            class: "w-10/12 cursor-pointer hover:opacity-80",
                            title: item.name,
                            for: item.id
                          }, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("img", {
                                src: 
                          item.file?.url ||
                          'https://video-thumb.s3.sa-east-1.amazonaws.com/65197bdbplaceholder.png'
                        ,
                                alt: "course_img",
                                class: "w-5/12 h-20 object-cover rounded"
                              }, null, 8, _hoisted_17),
                              _createElementVNode("p", _hoisted_18, _toDisplayString(item.name), 1)
                            ])
                          ], 8, _hoisted_15),
                          _createVNode(_component_Checkbox, {
                            modelValue: _ctx.selected,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selected) = $event)),
                            inputId: item.id,
                            value: item.id
                          }, null, 8, ["modelValue", "inputId", "value"])
                        ])
                      ]))
                    }), 128)),
                    _createVNode(_component_EmptyData, {
                      data: _ctx.courses.length == 0,
                      label: _ctx.emptyState.description,
                      image: _ctx.emptyState.image,
                      class: "col-span-12",
                      imgSize: "h-40 mt-10",
                      msgSize: "md:w-5/12 mb-10"
                    }, null, 8, ["data", "label", "image"])
                  ]))
                : _createCommentVNode("", true),
              (
                _ctx.courseParams.total && _ctx.courseParams?.total > _ctx.courseParams?.size
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_Paginator, {
                      rows: _ctx.courseParams?.size,
                      totalRecords: _ctx.courseParams?.total,
                      rowsPerPageOptions: [_ctx.courseParams?.size, 20, 30],
                      onPage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.paginate($event)))
                    }, null, 8, ["rows", "totalRecords", "rowsPerPageOptions"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createVNode(_component_Errors, {
            errors: _ctx.v$.selected.$errors
          }, null, 8, ["errors"])
        ])
      ], 32)
    ]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}